import { render, staticRenderFns } from "./IssoComment.vue?vue&type=template&id=6a783f00&scoped=true&"
import script from "./IssoComment.vue?vue&type=script&lang=js&"
export * from "./IssoComment.vue?vue&type=script&lang=js&"
import style0 from "./IssoComment.vue?vue&type=style&index=0&id=6a783f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a783f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a783f00')) {
      api.createRecord('6a783f00', component.options)
    } else {
      api.reload('6a783f00', component.options)
    }
    module.hot.accept("./IssoComment.vue?vue&type=template&id=6a783f00&scoped=true&", function () {
      api.rerender('6a783f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Isso/IssoComment.vue"
export default component.exports